import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import ColorInput from '../../../shared/components/ColorInput';
import CheckboxInput from '../../../shared/components/CheckboxInput'
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import RichTextInput from '../../../shared/components/RichTextInput';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';

import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validateTags } from '../../../shared/validators';

import {TEL_REGEX, URL_REGEX} from '../../../shared/utils'

class CampaignConclusionForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isShowingPopover:false,
      image:null,
      useCTA:true,
      useAppLink: false
    };
  }

  componentWillMount(){
    if(this.props.activeCampaignUseCTA && this.props.activeCampaignUseCTA === true){
      this.setState({useCTA:false});
    } else {
      this.setState({useCTA:true});
    }
    if(this.props.activeCampaignUseAppLink && this.props.activeCampaignUseAppLink === true){
      this.setState({useAppLink:true});
    } else {
      this.setState({useAppLink:false});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }

    if(nextProps.activeCampaignUseCTA !== this.state.useCTA){
      this.setState({useCTA:nextProps.activeCampaignUseCTA});
    }

    if(nextProps.activeCampaignUseAppLink !== this.state.useAppLink){
      this.setState({useAppLink:nextProps.activeCampaignUseAppLink});
    }
  }

  componentDidMount(){
    if(this.props.activeCampaignCompletionImageURL && this.props.activeCampaignCompletionFileName){
      this.setState({image:{
        fileName:this.props.activeCampaignCompletionFileName,
        medium:this.props.activeCampaignCompletionImageURL
      }});
    }
  }


  handleImageChange(newImage){
    this.setState({image:newImage});
  }

  handleSubmit(data){
    const image = this.state.image,
      validationMessages = {};

    if(image){
      data.completionImageURL = image.medium;
      data.completionImageFileName = image.fileName;
    }

    if(!data.completionText || data.completionText.replace(/<\/?[^>]+(>|$)/g, "").trim().length === 0){
      validationMessages['completionText'] = 'Text is required';
    }

    if(!image || !image.medium || image.medium === ""){
      validationMessages['completionImageURL'] = 'Conclusion image is required';
    }

    if(this.state.useCTA){
      data.useCTA = true;

      if(this.state.useAppLink) {
        data.useAppLink = true;
      } else {
        data.useAppLink = false;
        data.iosLink = null;
        data.androidLink = null;
      }
      if(!data.ctaLink){
        data.ctaLink = '';
      }

      if(!data.ctaText){
        data.ctaText = '';
      }

      if(!data.ctaColor){
        data.ctaColor = '';
      }

      if(!data.ctaText || data.ctaText.length === 0){
        validationMessages['ctaText'] = 'CTA text is required';
      }

      if(!data.ctaColor || data.ctaColor.length === 0){
        validationMessages['ctaColor'] = 'CTA color is required';
      }

      if(data.useAppLink) {
        if ((!data.iosLink || data.iosLink.length == 0) && (!data.androidLink || data.androidLink.length == 0)) {
          validationMessages['iosLink'] = 'Need at least a link for iOS or Android';
        }
      } else {
        if(!data.ctaLink || data.ctaLink.length === 0){
          validationMessages['ctaLink'] = 'CTA link is required';
        } else if(!(URL_REGEX.test(data.ctaLink) || TEL_REGEX.test(data.ctaLink))){
          validationMessages['ctaLink'] = 'Not a valid web address or phone number';
        }
      }
    } else {
      data.useCTA = false;
    }

    this.setState({validationMessages:validationMessages});
    this.props.onSubmit(data, Object.keys(validationMessages).length === 0);
  }

  render(){
    return (
      <Form
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='CompletionTextInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Wrap it up'
        >
          <p>
            Wrap up the experience and your conversation with your audience.
            <br /><br />
            Include an image that reinforces your experience message or promoted product.
          </p>
        </TutorialPopover>
        <RichTextInput
          id='CompletionTextInput'
          label='Text'
          name='completionText'
          multiline
          defaultValue={this.props.activeCampaignCompletionText}
          placeholder='Thanks for spending time with us!'
          warning={this.state.validationMessages['completionText']}
          maxLength={180}
        />
        <DroppableFileInput
          label='Image'
          fileType='image'
          name='completionImageURL'
          text='Upload conclusion image'
          onChange={(image) => this.handleImageChange(image)}
          warning={this.state.validationMessages['completionImageURL']}
          cropperAspectRatio={4/3}
          existingFileName={this.props.activeCampaignCompletionFileName}
          existingFileURL={this.props.activeCampaignCompletionImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.<br />Maximum file size of 2MB.</span>
          )}
        />
        <div>
        <Row>
          <Col xs='6'>
            <CheckboxInput
              name='useCTA'
              label='Include CTA Link'
              checked={this.state.useCTA}
              onClick={(e) => this.setState({useCTA:e.target.checked})}
              tooltip={(
                <div>
                  Link consumers to your web, e-commerce or social site to continue the conversation.<br /><br />  Call to action text examples:
                  <ul>
                    <li>Learn more</li>
                    <li>Buy now</li>
                    <li>Sign up</li>
                    <li>Register</li>
                  </ul>
                </div>
              )}
            />
          </Col>
          <Col xs='6'>
            <CheckboxInput
              name='useAppLink'
              label='Include CTA Link to App Store'
              checked={this.state.useAppLink}
              disabled={!this.state.useCTA }
              onClick={(e) => this.setState({useAppLink:e.target.checked})}
              tooltip={(
                <div>
                  Link Consumers directly to your Mobile App in iOS App Store or Android Google Play Store
                </div>
              )}
            />
          </Col>
        </Row>
        </div>
        {this.state.useCTA && (
          <div>
            <Row>
              <Col xs='12'>
                <br />
                <TextInput
                  label={'CTA Link' + (this.state.useAppLink ? ' - Web' : '')}
                  name='ctaLink'
                  placeholder='https:// or tel:'
                  defaultValue={this.props.activeCampaignCTALink}
                  warning={this.state.validationMessages['ctaLink']}
                />
              </Col>
            </Row>
            {this.state.useAppLink && (
              <div>
              <Row>
                <Col xs='12'>
                  <TextInput
                    label='CTA Link - Mobile iOS (App Store)'
                    name='iosLink'
                    placeholder='itms://'
                    defaultValue={this.props.activeCampaignIOSLink}
                    warning={this.state.validationMessages['iosLink']}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs='12'>
                  <TextInput
                    label='CTA Link - Mobile Android (Google Play)'
                    name='androidLink'
                    placeholder='market://'
                    defaultValue={this.props.activeCampaignAndroidLink}
                    warning={this.state.validationMessages['androidLink']}
                  />
                </Col>
              </Row>
              </div>
            )}
            <Row>
              <Col xs='8'>
                <TextInput
                  label='CTA Text'
                  name='ctaText'
                  placeholder='Visit Our Site'
                  defaultValue={this.props.activeCampaignCTAText}
                  maxLength={20}
                  warning={this.state.validationMessages['ctaText']}
                />
              </Col>
              <Col xs='4'>
                <ColorInput
                  label='CTA Background Color'
                  name='ctaColor'
                  placeholder='#ffffff'
                  defaultValue={this.props.activeCampaignCTAColor}
                  warning={this.state.validationMessages['ctaColor']}
                />
              </Col>
            </Row>
          </div>
        )}
        <br />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignConclusionForm.defaultProps = {
  onSubmit:() => {},
  isShowingTutorial:true
};

export default CampaignConclusionForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignConclusionForm.js